"use client"

import { MemoryStick } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MemoryStickIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MemoryStickIcon = component(Icon)({ as: MemoryStick })
